export const TOAST_LIFE_TIME_MS = 3200
export const toast = ref<ReturnType<typeof useToast>>()
export const toastErrorMessage = ref('')
